<template>
  <div class="form-group">
    <label
      :for="`form-field-${name}`"
      v-text="formatLabel()"
    />
    <Datepicker
      v-validate="validation"
      :value="formattedValue"
      :bootstrap-styling="true"
      :class="{'is-danger': errors.has(`form-field-${name}`)}"
      :data-vv-name="`form-field-${name}`"
      :data-vv-as="formatLabel()"
      :disabled-dates="{ from }"
      :monday-first="true"
      style="width:100%"
      :title="formatLabel()"
      @input="updateValue($event)"
    />
    <span
      v-if="errors.has(`form-field-${name}`)"
      class="has-error"
      v-text="errors.first(`form-field-${name}`)"
    />
    <span
      v-if="info"
      class="help-block"
      v-text="info"
    />
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import field from '../field.vue';

export default {
  components: { Datepicker },
  extends: field,
  props: {
    max: {
      type: String,
      default: null,
    },
  },
  computed: {
    from() {
      return this.max
        ? moment(this.max).add(1, 'days').toDate()
        : new Date();
    },
    formattedValue() {
      return this.value
        ? moment(this.value).toDate()
        : this.from;
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', moment(value).format('YYYY-MM-DD'));
    },
  },
};
</script>
<style>
.vdp-datepicker__calendar {
  bottom: 4rem;
}
.vdp-datepicker > .input-group {
  width: 100%;
}
.vdp-datepicker > .input-group > .form-control {
  background-color: #fff !important;
}
</style>
